<template>
  <el-row :gutter="10">
    <el-col :xl="24" :lg="24" :md="24" :sm="24">
      <div class="searchForm" :class="showLabel ? 'p-3 mt-2' : ''">
        <el-row :gutter="10">
          <el-col :xl="searchOnly ? 24 : 18" :lg="searchOnly ? 24 : 18" :md="15" :sm="24">
            <label for="search" v-if="showLabel">اختر اسم العميل</label>
            <input
              type="text"
              @focus="resetSearch"
              class="form-control"
              readonly
              v-model="placeholder"
              id=""
              v-if="selectedCustomer"
            />
            <el-select
              v-else
              @change="customerSelected"
              class="search customerQuery"
              @focus="options = []"
              v-model="value"
              :loading-text="loadingMsg"
              :no-data-text="noDataMsg"
              filterable
              popper-class="searchDropdown"
              remote
              :clearable="true"
              :placeholder="placeholder"
              :remote-method="remoteMethod"
              :loading="loading"
            >
              <el-option
                ref="customerQuery"
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
                <span style="float: right">
                  {{ item.name }} - {{ item.address }}</span
                >
              </el-option>
            </el-select>
          </el-col>
          <el-col
            v-if="selectedCustomer && searchOnly == false"
            :xl="6"
            :lg="6"
            :md="7"
            :sm="24"
            ><div class="bg-White result">
              <p style="margin: 0;">
                <span class="num" v-if="customerAccount >= 0">{{
                  numberToFixed(customerAccount)
                }}</span>
                <span class="num" v-else>{{
                  numberToFixed(customerAccount * -1)
                }}</span>
                <br />
                <span v-if="customerAccount >= 0">مدين</span>
                <span v-else>دائن</span>
              </p>
            </div></el-col
          >
        </el-row>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import axiosApi from "@/plugins/axios.js";

export default {
  name: "SearchCustomers",
  props: [
    "productsLength",
    "customer",
    "productSearch",
    "searchOnly",
    "showLabel",
    "useParcode",
  ],

  data() {
    return {
      selectedLabel: "",
      noDataMsg: "لا توجد بيانات متاحه",
      loadingMsg: " ... جاري تحميل البيانات",
      options: [],
      value: null,
      loading: false,
      placeholder: this.customer ? this.customer.name : "بحث العملاء",
      selectedCustomer: this.customer,
      customerAccount: this.customer
        ? this.customer.balance + this.customer.account
        : 0,
    };
  },
  mounted() {
    if (this.selectedCustomer) {
      this.placeholder = this.selectedCustomer.name;
    }
    if (!this.selectedCustomer) {
      document.querySelector(".customerQuery input").focus();
    }
  },
  methods: {
    setValue(value) {
      this.selectedCustomer = value;
      this.value = value;
      if (this.value != null) {
        this.placeholder = value.name;
        this.customerAccount = value.balance + value.account;
      } else {
        this.placeholder = "بحث العملاء";
        this.customerAccount = 0;
      }
      if (this.value) {
        setTimeout(() => {
          document.querySelector(".productQuery input").focus();
        }, 100);
      } else {
        setTimeout(() => {
          document.querySelector(".customerQuery input").focus();
        }, 100);
      }
    },
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    resetSearch() {
      if (this.productsLength == 0) {
        this.setValue(null);
        this.$emit("selectedCustomer", {
          customer: this.selectedCustomer,
        });
      }
    },
    customerSelected() {
      this.selectedCustomer = this.options.filter((customer) => {
        if (customer.id == this.value) {
          return customer;
        }
      })[0];
      if (this.selectedCustomer) {
        this.placeholder = this.selectedCustomer.name;
        this.customerAccount =
          this.selectedCustomer.balance + this.selectedCustomer.account;
      }
      this.$emit("selectedCustomer", {
        customer: this.selectedCustomer,
      });
    },
    remoteMethod(query) {
      if (query !== "") {
        this.selectedLabel = query;
        this.loading = true;
        axiosApi
          .get(`customers/search?query=${query}`)
          .then((res) => {
            this.loading = false;
            this.options = res.data;
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
          });
      } else {
        this.options = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
